var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3644_32088",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3644_32088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#C88A5D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#C88A5D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#C88A5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3636 17V12.7812L11.5455 13.4L11 12.68L12.3636 11.645V10.25H13.2727V10.9588L16 8.9L21 12.68L20.4545 13.3888L19.6364 12.7812V17H16.4545V14.3H15.5455V17H12.3636ZM12.3636 9.8C12.3636 9.425 12.4962 9.10625 12.7614 8.84375C13.0265 8.58125 13.3485 8.45 13.7273 8.45C13.8561 8.45 13.964 8.40688 14.0511 8.32063C14.1383 8.23438 14.1818 8.1275 14.1818 8H15.0909C15.0909 8.375 14.9583 8.69375 14.6932 8.95625C14.428 9.21875 14.1061 9.35 13.7273 9.35C13.5985 9.35 13.4905 9.39313 13.4034 9.47938C13.3163 9.56563 13.2727 9.6725 13.2727 9.8H12.3636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.88438b331c8a7ae76d23610f0b07a0bc.svg";
export { ForwardRef as ReactComponent };